import { render, staticRenderFns } from "./rc-crm-view-organization.vue?vue&type=template&id=86020714&scoped=true&"
import script from "./rc-crm-view-organization.vue?vue&type=script&lang=js&"
export * from "./rc-crm-view-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86020714",
  null
  
)

export default component.exports